import { createContext, useContext } from 'react';

interface ISidebarContext {
   isOpen: boolean;
   toggle?: () => void;
}                                                                        
export const SidebarContext = createContext<ISidebarContext>({ isOpen: true });
                                                                         
export const useSidebar = () => useContext(SidebarContext);